import customDropdown from "@/components/dropdown/customDropdown.vue";
import {
  BTable,
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BFormFile,
  BSpinner,
  BFormTags,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import debounce from "lodash/debounce";
import SkeletonLoaderVue from "skeleton-loader-vue";
import FileUpload from "@/components/FileUpload/index.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    customDropdown,
    BTable,
    BBadge,
    SkeletonLoaderVue,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BFormFile,
    BSpinner,
    BFormTags,
    BAvatar,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    FileUpload,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  data() {
    return {
      allowedDesignations: [
        "senior business development manager",
        "associate business development manager",
        "business development manager",
      ],
      limitedDesignations: [
        "Project Manager",
        "Technical Project Manager",
        "Associate Project Manager",
        "Senior Project Manager",
        "Business Analyst",
        "Junior Business Analyst",
      ],
      currentPage:
        (this.$route.query &&
          this.$route.query.page &&
          Number(this.$route.query.page)) ||
        1,
      totalCount: 0,
      perPage: this.$route.query.per_page || 100,
      sortBy: null,
      sortDesc: "desc",
      noCollapse: false,
      loading: true,
      search: null,
      remove_attachments: [],
      crmLinkError: '',
      fields: [
        { key: "project_name", label: "Project Name", thClass: "teamName", tdClass: "teamName" },
        { key: "client_name", label: "Client Name", thClass: "teamName", tdClass: "teamName" },
        { key: "description", label: "Description", thClass: "teamName", tdClass: "teamName" },
        { key: "project_type", label: "Project Type", thClass: "teamName", tdClass: "teamName", thStyle: { maxWidth: "130px", textAlign: "start" }},
        { key: "crm_lead_link", label: "CRM Lead Link", thClass: "teamName", tdClass: "teamName" },
        { key: "score", label: "Score", tdClass: "teamPrimary", thStyle: { maxWidth: "130px" } },
        { key: "tech_stack", label: "Tech Stack", tdClass: "teamSecondary", thStyle: { maxWidth: "130px" } },
        { key: "size", label: "Size", tdClass: "teamPrimary", thStyle: { maxWidth: "130px" } },
        { key: "status", label: "Status", tdClass: "teamPrimary", thStyle: { maxWidth: "130px" } },
        { key: "owner", label: "Owner", tdClass: "teamPrimary", thStyle: { maxWidth: "130px" } },
        { key: "assigned_to", label: "Assigned To", tdClass: "productivity", thStyle: { maxWidth: "500px" } },
        { key: "emptblLast", label: "action" },
      ],
      items: [],
      pageIndex: 0,
      project_title: "",
      client_company_name: "",
      description: "",
      crm_lead_link: "",
      lead_qualification_score: null,
      expected_tech_stack: "",
      project_size: null,
      proposal_type: "",
      attachments: [],
      images: [],
      pdfFile: [],
      isValidFile: true,
      FileErrorMsg: null,
      errorFileList: [],
      isEditing: false,
      isSaving: false,
      proposal_id: null,
      owner_ids: [],
      assignee_ids: [],
      status: [],
      user_id: null,
      userId: null,
      isFilterLoading: false,
      isInitialLoad: true,
      PREFERENCE_TYPE: "proposal_preference",
      managerUserList: [],
      bdeUserList: [],
      selectedOwner: null,
      selectedAssignee: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/project/task/image-store`,
        maxFiles: 20,
        uploadMultiple: true,
        parallelUploads: 100,
        thumbnailWidth: 150,
        maxFilesize: 10,
        acceptedFiles:
          '.jpeg, .jpg, .png, .txt, .pdf, .ppt,.pptx, .doc, .csv, .docx, .xls, .xlsx',
        dictDefaultMessage:
          "<b class='drop-title'>Drag & drop files</b> <br> <p class='drop-req'>Supported formats: JPEG, PNG, JPG, <br /> TXT, PDF, PPT, DOC, CSV, DOCX, XLS, XLSX <br /> ",
        addRemoveLinks: true,
      },
      showArchived: false,
    };
  },

  computed: {
    isFormValid() {
      return (
        this.project_title?.trim() &&
        this.client_company_name?.trim() &&
        this.description?.trim() &&
        this.crm_lead_link?.trim() &&
        this.lead_qualification_score?.trim() &&
        this.expected_tech_stack?.trim() &&
        this.project_size?.trim() &&
        this.proposal_type?.trim() &&
        this.isValidUrl(this.crm_lead_link)
      );
    },
    
    mappedBdeList() {
      console.log(this.bdeUserList);
      return this.bdeUserList?.map(user => ({
        value: user.id,
        label: user.full_name?.trim() || "",
        text: user.full_name?.trim() || "",
      })) || [];
    },

    mappedManagerList() {
      return this.managerUserList?.map(user => ({
        value: user.id,
        label: user.full_name?.trim() || "",
        text: user.full_name?.trim() || "",
      })) || [];
    },

    visibleFields() {
      const user = this.userInfo;
      if (!user) return [];

      let fields = [...this.fields];

      if (this.showArchived) {
        fields = fields.filter(f => f.key !== 'emptblLast');
      }
      if (user.role === "SA") {
        return fields;
      }

      const isLimitedDesignation =
        user.designation &&
        this.limitedDesignations.includes(user.designation);

      if (isLimitedDesignation) {
        const allowedKeys = [
          "project_name",
          "project_type",
          "tech_stack",
          "status",
          "assigned_to",
        ];
        return fields.filter(f => allowedKeys.includes(f.key));
      }

      return fields.filter(f => f.key !== "emptblLast");
    },

    queryData() {
      console.log('test');
      return {
        page: this.currentPage,
        per_page: this.perPage,
        owner_ids: this.owner_ids,
        assignee_ids: this.assignee_ids,
        status: this.status,
        user_id: this.user_id,
        userId: this.userInfo.id,
        search: this.search,
        sort_field: this.sortBy,
        sort_order: this.sortDesc ? "desc" : "asc",
        pageIndex: this.pageIndex,
        main_page: "proposal",
        archived: this.showArchived ? 1 : 0,
      };
    },

    canAddProposal() {
      return (
        this.userInfo?.role === "SA" ||
        (this.userInfo?.designation &&
          this.allowedDesignations.includes(this.userInfo.designation.toLowerCase()))
      );
    },

    debouncedSearch: {
      get() {
        return this.search;
      },
      set: debounce(function (value) {
        this.search = value;
        this.proposalData();
      }, 500),
    },
  },

  watch: {
    currentPage(value) {
      if (value) this.proposalData();
    },

    perPage: async function (newVal, oldVal) {
      if (this.isInitialLoad || this.isFilterLoading || newVal === oldVal) return;
      await this.saveFilterPreferences();
      this.currentPage === 1 ? this.proposalData() : (this.currentPage = 1);
    },
  },

  async mounted() {
    this.isInitialLoad = true;
    if (Object.keys(this.$route.query).length) this.setFilterValue();
    await this.loadFilterPreferences();
    this.userId = this.user_id;
    await this.userList();
    await this.proposalData();
    this.isInitialLoad = false;
  },

  methods: {
    async toggleArchived() {
      this.showArchived = !this.showArchived;
      this.currentPage = 1; // reset pagination
      this.routeQueryUpdate(this.queryData);
      await this.proposalData();
    },
    canEditOrDeleteProposal(item) {
      const user = this.$store.state.app.userInfo;
      if (!user || !item) return false;

      const isSuperAdmin = user.role === "SA";
      if (isSuperAdmin) return true; // SA can always edit/delete

      const isAllowedDesignation =
        user.designation &&
        this.allowedDesignations.includes(user.designation.toLowerCase());

      const isOwner = item.owner_id === user.id;
      const isNotCompleted = item.status !== "C";

      return isNotCompleted && isAllowedDesignation && isOwner;
    },

    validateCrmLeadLink() {
      if (this.crm_lead_link && !this.isValidUrl(this.crm_lead_link)) {
        this.crmLinkError = 'Please enter a valid URL (e.g., https://example.com)';
      } else {
        this.crmLinkError = '';
      }
    },
    
    isValidUrl(string) {
      if (!string) return false;

      const urlRegex = /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;
      return urlRegex.test(string.trim());
    },
    
    async userList() {
      const response = await this.getHTTPPostResponse(
        'proposal/proposal-user-list',
        {},
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.bdeUserList = data.bde_users
        this.managerUserList = data.manager_users
      }
    },
                                                                                                 
    /** Confirmation before delete proposal */
    async deleteConfirmation(data) {
      this.$swal({
        title: "Do you want to remove this proposal?",
        icon: "info",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonAriaLabel: "Thumbs down",
        customClass: {
          confirmButton: "btn confirm",
          cancelButton: "btn cancel ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteProposal(data.id);
        }
      });
    },

    /** delete proposal */
    async deleteProposal(id) {
      const response = await this.getHTTPDeleteResponse(
        `/proposal/delete/${id}`,
        {},
        true
      );
      if (response && response.status === 200) {
        this.proposalData();
      }
    },

    /** get status text */
    getStatusText(status) {
      const statusObj = this.proposalStatusList.find(
        (item) => item.value === status
      );
      return statusObj ? statusObj.label : status;
    },

    /** remove attachments */
    removeAttachments(index, id) {
      this.remove_attachments.push(id);
      this.task_attachments.splice(index, 1);
      this.attachments.splice(index, 1);
    },

    /** validation form */
    validationForm() {
      // First validate required fields
      if (!this.isFormValid) {
        this.$toast.error('Please fill in all required fields and ensure the CRM link is valid');
        return;
      }
      
      this.$refs.proposalObserver
        .validate()
        .then((success) => {
          if (success && this.isValidFile) {
            this.isSaving = true;
            if (this.isEditing) {
              this.updateProposal();
            } else {
              this.createProposal();
            }
          }
        })
        .catch((error) => {
          this.isSaving = false;
        });
    },

    /** create proposal */
    async createProposal() {
      this.loader = true;

      const proposalData = {
        project_title: this.project_title,
        client_company_name: this.client_company_name,
        description: this.description,
        crm_lead_link: this.crm_lead_link,
        lead_qualification_score: this.lead_qualification_score,
        expected_tech_stack: this.expected_tech_stack,
        project_size: this.project_size,
        proposal_type: this.proposal_type,
        owner_id: this.selectedOwner || null,
        assignees: this.selectedAssignee?.length
          ? this.selectedAssignee.map(userId => ({
              user_id: userId,
            }))
          : [],
        };

      if (this.pdfFile && this.pdfFile.length) {
        proposalData.files = this.pdfFile
          ? await Promise.all(
              this.pdfFile.map(async (file) => ({
                name: file.name,
                file: await this.convertFileToBase64(file),
              }))
            )
          : [];
      }
      const response = await this.getHTTPPostResponse(
        "proposal/create",
        proposalData,
        true
      );
      if (response && response.status === 200) {
        this.$bvModal.hide("add-proposal-modal");
        this.description = null;
        this.resetModal();
        this.proposalData();
      }

      this.loader = false;
    },

    /** reset modal */
    resetModal() {
      this.proposal_id = null;
      this.project_title = "";
      this.client_company_name = "";
      this.description = "";
      this.crm_lead_link = "";
      this.lead_qualification_score = null;
      this.expected_tech_stack = "";
      this.project_size = null;
      this.proposal_type = "";
      this.attachments = [];
      this.images = [];
      this.pdfFile = [];
      this.isValidFile = true;
      this.FileErrorMsg = null;
      this.errorFileList = [];
      (this.isSaving = false), (this.remove_file_ids = []);
      this.isEditing = false;
      this.selectedOwner = null;
      this.selectedAssignee = [];

      // Reset form validation
      if (this.$refs.proposalObserver) {
        this.$refs.proposalObserver.reset();
      }
    },

    /** close modal */
    closeModal() {
      this.resetModal();
      this.$bvModal.hide("add-proposal-modal");
    },

    /** set filter value */
    setFilterValue() {
      const query = this.$route.query || {};
      this.perPage = query.per_page ? Number(query.per_page) : this.perPage;
      this.currentPage = query.page ? Number(query.page) : this.currentPage;
      this.search = query.search || this.search;
      this.pageIndex = query.pageIndex ? Number(query.pageIndex) : 0;
      this.status = query.status
        ? Array.isArray(query.status)
          ? query.status
          : [query.status]
        : [];
      this.owner_ids = query.owner_ids
        ? Array.isArray(query.owner_ids)
          ? query.owner_ids
          : [query.owner_ids]
        : [];
      this.assignee_ids = query.assignee_ids
        ? Array.isArray(query.assignee_ids)
          ? query.assignee_ids
          : [query.assignee_ids]
        : [];

      this.showArchived = Number(query.archived) == 1;
    },

    /** proposal details */
    proposalDetails(id) {
      this.pageIndex = window.scrollY;
      this.$router.push({
        name: "ProposalDetails",
        params: {
          id,
        },
        query: this.queryData,
      });
    },

    async applyFilters() {
      await this.saveFilterPreferences();
      this.currentPage = 1;
      this.proposalData();
    },
    
    /** Clear all filters */
    async clearFilter() {
      this.status = [];
      this.owner_ids = [];
      this.assignee_ids = [];
      this.search = null;
      this.currentPage = 1;
      this.perPage = 10; // Reset to default

      // Clear URL query params
      if (this.$route.query) {
        this.$router.replace({ query: null }).catch(() => {});
      }

      // Save cleared state
      await this.saveFilterPreferences();
      this.proposalData();
    },

    /* proposal list get */
    async proposalData() {
      const input = this.commonPayloadObject(); // Generate the common payload object
      this.routeQueryUpdate(this.queryData); // This will update the URL with current filters
      await this.fetchProposalData(input); // Fetch the team data otherwise
    },

    /* common payload */
    commonPayloadObject() {
      return {
        page: this.currentPage,
        per_page: this.perPage,
        sort_field: this.sortBy,
        sort_order: this.sortDesc ? "desc" : "asc",
        search: this.search,
        status: this.status,
        user_id: this.user_id,
        userId: this.userInfo.id,
        assignee_ids: this.assignee_ids,
        owner_ids: this.owner_ids,
        is_archived: this.showArchived ? 1 : 0,
      };
    },

    /** edit proposal */
    editProposal(item) {
      this.resetModal();
      this.isEditing = true;
      this.proposal_id = item.id;
      this.project_title = item.project_title || "";
      this.client_company_name = item.client_company_name || "";
      this.description = item.description || "";
      this.crm_lead_link = item.crm_lead_link || "";
      this.lead_qualification_score = item.lead_qualification_score || null;
      this.expected_tech_stack = item.expected_tech_stack || "";
      this.project_size = item.project_size || null;
      this.proposal_type = item.proposal_type || "";
      this.selectedOwner = item.owner_id;
      this.selectedAssignee = item.proposal_assignees.map(assignee => assignee.user_id);
      if (item.proposal_attachments && item.proposal_attachments.length > 0) {
      this.attachments = item.proposal_attachments
        .filter(attachment => attachment.is_proposed === 0)
        .map((attachment) => ({
          id: attachment.id,
          name: attachment.name || "Unnamed File",
          url: attachment.url,
          size: attachment.size || 0,
          type: attachment.type || "application/octet-stream",
        }));

        this.$nextTick(() => {
          this.attachments.forEach((attachment) => {
            this.$refs.fileDropzone.manuallyAddFile(attachment, attachment.url);
          });
        });
      }

      this.$bvModal.show("add-proposal-modal");
    },

    /** update proposal */
    async updateProposal() {
      this.loader = true;
      this.isSaving = true;

      const proposalData = {
        _method: "PUT",
        project_title: this.project_title,
        client_company_name: this.client_company_name,
        description: this.description,
        crm_lead_link: this.crm_lead_link,
        lead_qualification_score: this.lead_qualification_score,
        expected_tech_stack: this.expected_tech_stack,
        project_size: this.project_size,
        proposal_type: this.proposal_type,
        remove_file_ids: this.remove_attachments || [],
        owner_id: this.selectedOwner,
        assignees: this.selectedAssignee?.length
          ? this.selectedAssignee.map(userId => ({
              user_id: userId,
            }))
          : [],
      };

      if (this.pdfFile && this.pdfFile.length) {
        proposalData.files = await Promise.all(
          this.pdfFile.map(async (file) => ({
            name: file.name,
            file: await this.convertFileToBase64(file),
          }))
        );
      }

      const response = await this.getHTTPPostResponse(
        `proposal/update/${this.proposal_id}`,
        proposalData,
        true
      );

      if (response && response.status) {
        this.$bvModal.hide("add-proposal-modal");
        this.resetModal();
        this.proposalData();
      }

      this.loader = false;
      this.isSaving = false;
    },

    /** fetch proposal data */
    async fetchProposalData(input) {
      this.loading = true;

      const response = await this.getHTTPPostResponse("proposal", input, false);
      if (response && response.data) {
        this.items = response.data.proposal;
        this.totalCount = response.data.count ?? 0;
      }

      this.loading = false;
      this.$nextTick(() => {
        document.documentElement.scrollTop = this.pageIndex;
      });
      setTimeout(() => {
        this.pageIndex = 0;
      }, 1000);
    },

    getRemainingAssignees(assignees) {
      if (!assignees || assignees.length <= 2) return '';
      return assignees
        .slice(2)
        .map(function (a) {
          return a.user && a.user.full_name ? a.user.full_name : 'N/A';
        })
        .join(', ');
    },

    handleFileUpload($event) {
      this.pdfFile = $event.file;
      this.isValidFile = $event.isValidFile;
    },

    async saveFilterPreferences() {
      const preferenceData = {
          filters: {
            status: this.status,
            owner_ids: this.owner_ids,
            assignee_ids: this.assignee_ids,
            search: this.search,
          },
          pagination: {
            per_page: this.perPage,
          },
        };

        await this.getHTTPPostResponse(
          "user-filter-preference/createOrUpdate",
          {
            preference_type: this.PREFERENCE_TYPE,
            filters: preferenceData.filters,
            pagination: preferenceData.pagination,
          },
          false
        );
    },

    /** Load saved filter preferences */
    async loadFilterPreferences() {
        this.isFilterLoading = true;
        const response = await this.getHTTPPostResponse(
          "user-filter-preference",
          {
            preference_type: this.PREFERENCE_TYPE,
          },
          false
        );

        if (response && response.data && response.data.data) {
          const { filters, pagination } = response.data.data;

          if (filters) {
            this.status = Array.isArray(filters.status) ? [...filters.status] : [];
            this.owner_ids = Array.isArray(filters.owner_ids) ? [...filters.owner_ids] : [];
            this.assignee_ids = Array.isArray(filters.assignee_ids) ? [...filters.assignee_ids] : [];
            this.search = filters.search || null;
            
            this.$nextTick(() => {
              this.routeQueryUpdate(this.queryData);
            });
          }

          if (pagination && pagination.per_page) {
            this.perPage = pagination.per_page;
          }
          
          if (this.isInitialLoad) {
            this.isInitialLoad = false;
          }
        }
        this.isFilterLoading = false;
    },
  },
};
